<template>
  <div>
    <v-container>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-dialog v-model="dlgEdit" width="800px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" small dark class="mb-2" @click="addItem" v-bind="attrs" v-on="on">添加用户</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ dlgTitle }}</span>
            </v-card-title>
            <v-card-text style="height:300px;padding:10px;">
              <v-container grid-list-md>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">登录名</span>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="edItem.username" dense solo
                      :readonly="edID > 0"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="fld">
                    <span class="flds">姓名</span>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="edItem.name" dense solo></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">邮箱</span>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="edItem.email" dense solo></v-text-field>
                  </v-col>
                  <v-col cols="2" class="fld">
                    <span class="flds">密码</span>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="edItem.password" type="password" dense solo></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="管理员" value='admin' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="生产管理" value='producemng' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="仓储笼" value='cage' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="报废仓储笼" value='scrap_cage' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="取消发出仓储笼" value='unsendcage' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="取消收回仓储笼" value='dereturncage' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="出库" value='stockout' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="客户管理" value='customer' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="釜票管理" value='formula' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="增加生产计划" value='add_produce' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="实际生产" value='pd_produce' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="删除生产" value='del_produce' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <v-flex><v-checkbox label="删除出库" value='del_stockout' v-model="sel_roles"></v-checkbox></v-flex>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" small text @click="cancel">取消</v-btn>
              <v-btn color="primary" small @click="save">确定</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="users"
        :server-items-length="pagination.totalItems"
        :loading="loading"
        hide-default-footer
        class="elevation-1">
        <template v-slot:item.act="{item}">
          <v-btn x-small class="mr-2" @click="editItem(item)" color="primary">修改</v-btn>
          <v-btn x-small color="error" text @click="deleItem(item)">删除</v-btn>
        </template>
        <template slot="no-data">
          没有数据
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pagination.totalPages"></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import { getUserList, addUser, modifyUser, deleteUser } from '@/api/user'
import { MsgError } from '@/libs/util';

export default {
  components: {
  },
  data: () => ({
    dlgRight: false,
    dlgEdit: false,
    edID: 0,
    edItem: {
      username: '',
      name: '',
      email: '',
      password: '',
      roles: ''
    },
    sel_roles: [],
    headers: [
      { text: '登录名', value: 'username', sortable: false },
      { text: '姓名', value: 'name', sortable: false },
      { text: 'Email', value: 'email', sortable: false },
      { text: '操作', value: 'act', sortable: false }
    ],
    users: [],
    pagination: {
      page: 0,
      sortBy: '',
      descending: false,
      rowsPerPage: 10,
      totalItems: 0,
      totalPages: 0
    },
    loading: false
  }),
  methods: {
    addItem () {
      this.edID = 0
      this.edItem.username = ''
      this.edItem.name = ''
      this.edItem.email = ''
      this.edItem.password = ''
      this.edItem.roles = ''
      this.sel_roles = []
    },
    editItem (item) {
      this.edID = item.id
      this.edItem = Object.assign({}, item)
      this.edItem.password = ''
      this.sel_roles = this.edItem.roles.split(',')
      this.dlgEdit = true
    },
    doDele (id) {
      deleteUser(id).then(res => {
        this.reload()
      })
    },
    deleItem (item) {
      this.$swal.fire({
        title: '警告',
        text: '确实要删除码?',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then((result) => {
        if (result.isConfirmed) {
          this.doDele(item.id);
        }
      })
    },
    cancel () {
      this.dlgEdit = false
    },
    save () {
      if (this.edID > 0) {
        modifyUser(this.edID, this.edItem.name, this.edItem.email, this.edItem.password, this.sel_roles.join(',')).then(res => {
          this.reload()
        })
      } else {
        if (this.edItem.password === undefined || this.edItem.password === '') {
          MsgError('密码不能为空')
          return
        }
        addUser(this.edItem.username, this.edItem.name, this.edItem.email, this.edItem.password, this.sel_roles.join(',')).then(res => {
          this.reload()
        })
      }
      this.cancel()
    },
    reload () {
      let d = {
        'page': this.pagination.page,
        'perPage': this.pagination.rowsPerPage
      }
      this.loading = true
      getUserList(d).then(res => {
        this.users = res.data.items
        if (res.data._meta.page > res.data._meta.total_pages) {
          this.pagination.page = res.data._meta.total_pages
        } else {
          this.pagination.page = res.data._meta.page
        }
        this.pagination.totalPages = res.data._meta.total_pages
        this.pagination.totalItems = res.data._meta.total_items
        this.loading = false
      })
    }
  },
  computed: {
    dlgTitle () {
      return this.edID <= 0 ? '添加用户' : '修改用户'
    }
  },
  watch: {
    pagination: {
      handler () {
        this.reload()
      },
      deep: true
    }
  },
  mounted () {
    this.reload()
  }
}
</script>
